<template>
    <div class="landing">
        <div class="landing__container">

            <!-- Logo -->
            <div class="landing__logo" ref="logo">
                <a href="#" @click.prevent class="logo">
                    <logo alt="logo" ref="logo"></logo>
                </a>
            </div>

            <!-- Title -->
            <div class="landing__title" ref="title">
                <p>Hello!</p>
            </div>

            <!-- Subtitle -->
            <div class="landing__subtitle" ref="subtitle">
                <p>Ready to reconnect<br> the whole family?</p>
            </div>

        </div>

        <!-- Next Button -->
        <button @click="readyClicked" class="landing__button" href="#" ref="button">
            <span>I'm Ready</span>
        </button>

    </div>
</template>

<script>
    import { TimelineMax } from 'gsap';

    import logo from '@/assets/svg/logo.svg';

    let tl = new TimelineMax({
        delay: 0.5
    });

    export default {
        name: 'Landing',
        components: {
            logo
        },
        methods: {
            readyClicked() {
                this.$emit('nextStep');
            }
        },
        mounted() {
            const {logo, title, subtitle, button} = this.$refs;
            tl
            .from(logo, .9, {scale: .8, autoAlpha: 0, ease: Power2.easeOut})
            .from([title, subtitle], 0.8, {autoAlpha: 0, ease: Power2.easeOut}, "-=.4")
            .from(button, 1.2, {autoAlpha: 0, y: 100, ease: Power2.easeOut}, "-=.8")
        }
    }
</script>




// WEBPACK FOOTER //
// Landing.vue?e2effdfc